// Generate years array (from current year down to 1900)
const currentYear = new Date().getFullYear();
export const years = [];
for (let year = currentYear; year >= 1900; year--) {
  years.push(year);
}
